import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ExpandableSection } from '../../components/expandableSection';
import { GameGuideHelpButton } from '../../components/gameGuideHelpButton';
import { useAppSelector } from '../../redux/store';
import { PanelItem } from '../panelItem';
import { MyBombAmmoDisplaySeatedPlayerWrapper } from './myBombAmmoDisplaySeatedPlayerWrapper';
import { TargetedBombButtonsContainer } from './targetedBombButtonsContainer';
export const BombsSubPanelContainer = ({ playerIdName, isSelfPanel }) => {
    const roomSceneType = useAppSelector((state) => state.scene.roomSceneType);
    const mySeatIndex = useAppSelector((state) => state.poker.mySeatIndex);
    if (roomSceneType !== 'poker') {
        // can only use bombs in poker rooms
        return null;
    }
    if (isSelfPanel && mySeatIndex === undefined) {
        // when wanting to bomb self and you aren't sitting, don't show anything bomb-related:
        return null;
    }
    return (_jsxs(ExpandableSection, { expandableSectionType: isSelfPanel ? 'self-bombs' : 'player-bombs', colorType: 'player-info', headerRight: _jsx(GameGuideHelpButton, { pageType: 'bombs', title: 'Bombs & Charms Info' }), children: [_jsx(PanelItem, { children: _jsx(TargetedBombButtonsContainer, { playerIdName: playerIdName }) }), _jsx(MyBombAmmoDisplaySeatedPlayerWrapper, { playerId: playerIdName.id })] }));
};
